<script type="text/ecmascript-6">
    import AxAttributesBase from './AxAttributesBase';

    export default {
        extends: AxAttributesBase,
        props: {
            'variantColor': Object,
        },
        data() {
            return {}
        },
        methods: {
        },
    }
</script>

<template>
    <div :id="'axindex-'+variantColor.articleNr" :ref="'axindex-'+variantColor.articleNr">
        <h4>Farbvariante (<span v-text="variantColor.articleNr"></span>)</h4>
        <hr>
        <div class="row p-w-xl">
            <div class="col-md-6 m-b-md">
                <h5 class="m-b-xs">Farbbezeichnung</h5>
                <p class="text-muted m-b-md" v-text="variantColor.name"></p>
                <div v-if="variantColor.marketing_name">
                    <h5 class="m-b-xs">Farbe</h5>
                    <p class="text-muted m-b-md" v-text="variantColor.marketing_name"></p>
                </div>
            </div>
        </div>
    </div>
</template>
